import {makeThemeProps} from "src/themes/utils";

export default (theme, site) => {
  const themeStyles = makeThemeProps(theme, site);
  return themeStyles.getShowcasedProductListProps(theme);
};
